import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: 'Programerska radionica DIGITAL',
      metaTags: [
        {
          name: 'description',
          content: 'Programerska radionica DIGITAL je privatna firma osnovana 2017. godine sa sjedištem u Maglaju, Bosna i Hercegovina. Firma se bavi razvojem, podrškom i održavanjem digitalnih proizvoda.'
        },
        {
          name: 'keywords',
          content: 'programerska, radionica, digital'
        },
        {
          name: 'copyright',
          content: 'Programerska radionica DIGITAL'
        },
        {
          name: 'author',
          content: 'Vahid Smajlagic'
        },
        {
          name: 'robots',
          content: 'index, nofollow, noarchive'
        },
        {
          name: 'Classification',
          content: 'Business'
        },
        {
          name: 'coverage',
          content: 'Worldwide'
        },
        {
          name: 'distribution',
          content: 'Global'
        },
        {
          name: 'revisit-after',
          content: '7 days'
        },
        {
          name: 'Expires',
          content: '0'
        },
        {
          name: 'Pragma',
          content: 'no-cache'
        },
        {
          name: 'Cache-Control',
          content: 'no-cache'
        },
        {
          property: 'og:title',
          content: 'Programerska radionica DIGITAL'
        },
        {
          property: 'og:description',
          content: 'Programerska radionica DIGITAL je privatna firma osnovana 2017. godine sa sjedištem u Maglaju, Bosna i Hercegovina. Firma se bavi razvojem, podrškom i održavanjem digitalnih proizvoda.'
        },
        {
          property: 'og:email',
          content: 'programerska@radionica.digital'
        },
        {
          property: 'fb:page_id',
          content: '1440711379285029'
        },
        {
          property: 'apple-mobile-web-app-capable',
          content: 'yes'
        }
      ]
    },
    component: Home
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;
  if(!nearestWithMeta) return next();
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');
    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });
    return tag;
  })
  .forEach(tag => document.head.appendChild(tag));
  next();
});

export default router
